import { GLOBAL } from '../constants/Global';
import { EnvType } from '../enums/EnvType';
import { SentryEnv } from '../enums/SentryEnv';

export const GetSentryEnvironment = (): any => {
	switch (GLOBAL.REACT_ENV) {
		case EnvType.LOCAL:
			return SentryEnv.TEST;
		case EnvType.DEV:
			return SentryEnv.DEV;
		case EnvType.PROD:
			return SentryEnv.PROD;
	}
};
